import React from 'react';
import {Tab} from '@headlessui/react';
import TabContent from './TabContent';
import Categories from './Categories';

import {useAccountScoreSettingQuery} from 'api';

export default () => {
  const {data: {accountScoreSetting = {}} = {}} = useAccountScoreSettingQuery(
    {},
  );
  function classNames(...classes: string[]) {
    return classes.filter(Boolean).join(' ');
  }

  const priorities = [1, 2, 3, 4, 5];
  return (
    <div className="p-6 bg-c-bg flex-1 flex flex-col gap-4 rounded-b overflow-y-scroll">
      <div className="bg-white p-6 rounded flex flex-col gap-2 overflow-y-scroll">
        <Tab.Group>
          <Tab.List className="flex space-x-1 rounded-sm p-1 bg-[#F3F5F7] w-[484px]">
            {priorities.map((priority) => (
              <Tab
                className={({selected}) =>
                  classNames(
                    'w-52  py-1 text-sm font-medium leading-5 focus:outline-none cursor-pointer',
                    selected
                      ? 'text-[#495058] bg-white'
                      : 'text-[#BDC4CB] bg-[#F3F5F7]',
                  )
                }>
                <div className="flex items-center gap-2 justify-center">
                  <span>優先度{priority}</span>
                  <span className="bg-[#F3F5F7] rounded-full px-1 text-[10px]">
                    {accountScoreSetting?.subCategoriesGroupByPriority?.[
                      priority
                    ]?.length ?? 0}
                  </span>
                </div>
              </Tab>
            ))}
          </Tab.List>
          <Tab.Panels className="mt-2 h-full w-full">
            {priorities.map((priority) => {
              return (
                <Tab.Panel
                  className={'bg-white p-3 focus:outline-none'}
                  key={priority}>
                  <div className="flex flex-col h-[700px] bg-white">
                    <TabContent priority={priority} />
                    <div className="border my-3 border-[#E6E6E6]"></div>
                    <Categories />
                  </div>
                </Tab.Panel>
              );
            })}
          </Tab.Panels>
        </Tab.Group>
      </div>
    </div>
  );
};
